import { render, staticRenderFns } from "./TableCreateWizard.vue?vue&type=template&id=1ee3a6e8&scoped=true&"
import script from "./TableCreateWizard.vue?vue&type=script&lang=js&"
export * from "./TableCreateWizard.vue?vue&type=script&lang=js&"
import style0 from "./TableCreateWizard.vue?vue&type=style&index=0&id=1ee3a6e8&scoped=true&lang=css&"
import style1 from "./TableCreateWizard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee3a6e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
